import { Component, OnInit, ViewChild, ComponentFactoryResolver, ComponentFactory, ComponentRef } from '@angular/core';
import { PopupService } from './popup.service';
import { PopupDirective } from './popup.directive';
import { HtmlPopupItem } from './items/html-popup-item';
import { IframePopupItem } from './items/iframe-popup-item';
import { IframeComponent } from './iframe/iframe.component';
import { ConfirmPopupItem } from './items/confirm-popup-item';
import { IPopupItem } from './items/popup-item';
import { ConfirmComponent } from './confirm/confirm.component';

@Component({
  selector: 'ng-popup',
  template: `<div id="app-popup" [ngClass]="{'open': isOpen, 'confirm': isConfirm, 'iframe': isIframe}" (click)="dismiss($event)">

  <div class="app-popup-container" [ngClass]="options.id">

    <div class="app-popup-spinner" *ngIf="isOpen && isIframe && options.spin && spinning"></div>

    <div class="app-popup-close" (click)="close()" *ngIf="options.showClose"></div>

    <div class="app-popup-content" [ngClass]="{'spin': isOpen && isIframe && options.spin && spinning}">

      <ng-template popup-host></ng-template>

    </div>

    <div class="app-popup-confirm">

      <p class="popup-label-cancel" (click)="cancel()">{{ options.cancelText }}</p>

      <p class="popup-label-confirm" (click)="confirm()">{{ options.confirmText }}</p>

    </div>

  </div>

</div>`,
  styles: [`#app-popup{display:none;position:absolute;top:0;left:0;height:100vh;width:100vw;background-color:rgba(0,0,0,.6);align-items:center;justify-content:center}#app-popup .app-popup-container{position:relative;min-width:300px;max-width:80vw;min-height:250px;max-height:80vh;background-color:#fff;border-radius:3px;box-shadow:0 1px 4px 0 rgba(0,0,0,.08);display:flex;flex-direction:column}#app-popup .app-popup-container .app-popup-close{position:absolute;z-index:1;top:16px;right:16px;height:25px;width:25px;background-image:url(assets/close.svg);background-size:10px 10px;background-position:center;background-repeat:no-repeat;cursor:pointer}#app-popup .app-popup-container .app-popup-content{box-sizing:border-box;padding:20px 30px;max-height:calc(80vh - 30px);overflow:hidden;overflow-y:auto}#app-popup.confirm .app-popup-container{max-width:500px}#app-popup .app-popup-container .app-popup-content.spin{-webkit-filter:blur(3px);filter:blur(3px)}#app-popup .app-popup-container .app-popup-confirm{width:100%;height:60px;display:none;margin-top:auto;border-top:1px solid}#app-popup .app-popup-container .app-popup-confirm>p{width:50%;height:100%;cursor:pointer;line-height:60px;text-align:center;margin:0;font-size:24px}#app-popup .app-popup-container .app-popup-confirm>p.popup-label-cancel{border-right:1px solid}#app-popup.confirm .app-popup-container .app-popup-content{max-height:calc(80vh - 90px)}#app-popup.confirm .app-popup-container .app-popup-confirm,#app-popup.open{display:flex}#app-popup .app-popup-spinner{height:100%;width:100%;position:absolute;top:0;left:0;background-color:transparent;z-index:10}#app-popup .app-popup-spinner:after{content:'';position:absolute;top:50%;left:50%;height:40px;width:40px;-webkit-transform:translate3d(-50%,-50%,0);transform:translate3d(-50%,-50%,0);border:3px solid gray;border-top-color:transparent;border-radius:50%;-webkit-animation:1s linear infinite spin;animation:1s linear infinite spin}@keyframes spin{0%{-webkit-transform:translate(-50%,-50%) rotate(0);transform:translate(-50%,-50%) rotate(0)}100%{-webkit-transform:translate(-50%,-50%) rotate(360deg);transform:translate(-50%,-50%) rotate(360deg)}}@-webkit-keyframes spin{0%{-webkit-transform:translate(-50%,-50%) rotate(0);transform:translate(-50%,-50%) rotate(0)}100%{-webkit-transform:translate(-50%,-50%) rotate(360deg);transform:translate(-50%,-50%) rotate(360deg)}}`]
})
export class PopupComponent implements OnInit {

  @ViewChild(PopupDirective) appPopup: PopupDirective;

  isOpen = false;
  isConfirm = false;
  isIframe = false;
  isHtml = false;
  spinning = false;

  options: any = {};
  default_options = {
    id: '',
    dismissable: true,
    title: 'Title',
    text: 'Text',
    cancelText: 'Cancel',
    confirmText: 'Confirm',
    showClose: true,
    spin: true,
  }

  constructor(public popup: PopupService, private componentFactoryResolver: ComponentFactoryResolver) { }

  ngOnInit() {
    this.popup.popupSource$.subscribe(this.handleOpenEvent);
    this.popup.iframeLoadSource$.subscribe(this.handleLoadEvent);
  }

  handleOpenEvent = (popupItem: IPopupItem) => {
    if (!popupItem)
      this.close();

    else if (popupItem.type === 'html-popup')
      this.openHtml(<HtmlPopupItem> new HtmlPopupItem(popupItem));

    else if (popupItem.type === 'confirm-popup')
      this.openConfirm(<ConfirmPopupItem> new ConfirmPopupItem(popupItem));

    else if (popupItem.type === 'iframe-popup')
      this.openIframe(<IframePopupItem> new IframePopupItem(popupItem));

    return;
  }

  openHtml(htmlPopupItem: HtmlPopupItem) {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(htmlPopupItem.component);

    this.openPopup(componentFactory, htmlPopupItem.options);

    this.isHtml = true;
  }

  openIframe(iframePopupItem: IframePopupItem) {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(iframePopupItem.component);

    let componentRef = this.openPopup(componentFactory, iframePopupItem.options);
    (<IframeComponent>componentRef.instance).url = iframePopupItem.url;

    this.isIframe = true;
  }

  openConfirm(confirmPopupItem: ConfirmPopupItem) {
    let componentFactory = this.componentFactoryResolver.resolveComponentFactory(confirmPopupItem.component);

    let componentRef = this.openPopup(componentFactory, confirmPopupItem.options);
    (<ConfirmComponent>componentRef.instance).title = confirmPopupItem.title;
    (<ConfirmComponent>componentRef.instance).text = confirmPopupItem.text;

    this.isConfirm = true;
  }

  openPopup(componentFactory: ComponentFactory<{}>, options) {
    this.close();
    this.isOpen = true;

    let default_options = JSON.parse(JSON.stringify(this.default_options));
    this.options = Object.assign(default_options, options);

    if (this.options.spin)
      this.spinning = true;

    let viewContainerRef = this.appPopup.viewContainerRef;
    return viewContainerRef.createComponent(componentFactory);
  }

  handleLoadEvent = () => {
    if (this.options.spin)
      this.spinning = false;
  }

  dismiss(event) {
    if (event.target.id === 'app-popup' && this.options.dismissable)
      this.close();
  }

  cancel() {
    let cancel = this.options.cancel;
    if (typeof cancel === 'function')
      cancel();
  }

  confirm() {
    let confirm = this.options.confirm;
    if (typeof confirm === 'function')
      confirm();
  }

  close() {
    let viewContainerRef = this.appPopup.viewContainerRef;
    viewContainerRef.clear();

    this.isOpen = false;
    this.isConfirm = false;
    this.isIframe = false;
    this.isHtml = false;
    this.spinning = false;
  }

}
